import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

/**
 * Section reveal — opacity + 16px y-shift over 600ms on viewport enter.
 * Simple, reliable, editorial. (Tried clipPath wipe — fragile across browsers.)
 */
export const Reveal = ({
    children,
    delay = 0,
    duration = 0.6,
    amount = 0.18,
    className = "",
    ...rest
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount, margin: "-50px" }}
            transition={{ duration, ease: EASE, delay }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
};
